import React from "react";
import * as Assets from "./assets";

export interface Props {
  name:
    | "arrowBack"
    | "arrowDown"
    | "close"
    | "done"
    | "download"
    | "favorite"
    | "home"
    | "errorLocal"
    | "errorServer"
    | "inputDelete"
    | "play"
    | "ratio_1_1"
    | "ratio_16_9"
    | "ratio_9_16"
    | "search"
    | "share"
    | "time"
    | "ImgDownload"
    | "comment"
    | "delete"
    | "restore"
    | "consoleSearch"
    | "commentMenu"
    | "historyMenu"
    | "svgMix"
    | "commentConsole"
    | "svgSettingIcon"
    | "swipeRight"
    | "swipeLeft"
    | "svgRecent"
    | "svgMixed"
    | "svgSearchHome"
    | "svgNewArrow"
    | "LoadingMix"
    | "Subscribe"
    | "NewWindows"
    | "svgModeration"
    | "svgTemplates"
    | "noImage"
    | "PlayButton";

  size?: number;
  color?: string;
  opacity?: number;
}

const IconView = ({ name, size = 16, color, opacity }: Props) => {
  const props = {
    width: size,
    height: size,
    color,
    opacity,
  };

  if (name === "ratio_1_1") {
    return <img src={Assets.ImgRatio11} alt="ratio_1_1" {...props} />;
  } else if (name === "ratio_16_9") {
    return <img src={Assets.ImgRatio169} alt="ratio_16_9" {...props} />;
  } else if (name === "ratio_9_16") {
    return <img src={Assets.ImgRatio916} alt="ratio_9_16" {...props} />;
  } else if (name === "time") {
    return <img src={Assets.ImgTime} alt="time" {...props} />;
  } else if (name === "LoadingMix") {
    return <img src={Assets.LoadingMix} alt="loadingMix" {...props} />;
  } else if (name === "Subscribe") {
    return <img src={Assets.Subscribe} alt="subscribe" {...props} />;
  } else if (name === "NewWindows") {
    return <img src={Assets.NewWindows} alt="newWindows" {...props} />;
  } else if (name === "PlayButton") {
    return <img src={Assets.PlayButton} alt="playButton" {...props} />;
  } else if (name === "noImage") {
    return <img src={Assets.NoImage} alt="noImage" {...props} />;
  } else if (name === "arrowBack") {
    return <Assets.SvgArrowBack {...props} />;
  } else if (name === "arrowDown") {
    return <Assets.SvgArrowDown {...props} />;
  } else if (name === "close") {
    return <Assets.SvgClose {...props} />;
  } else if (name === "done") {
    return <Assets.SvgDone {...props} />;
  } else if (name === "download") {
    return <img src={Assets.ImgDownload} alt="time" {...props} />;
    // return <Assets.SvgDownload {...props} />;
  } else if (name === "errorLocal") {
    return <Assets.SvgErrorLocal {...props} />;
  } else if (name === "errorServer") {
    return <Assets.SvgErrorServer {...props} />;
  } else if (name === "favorite") {
    return <Assets.SvgFavorite {...props} />;
  } else if (name === "home") {
    return <Assets.SvgHome {...props} />;
  } else if (name === "inputDelete") {
    return <Assets.SvgInputDelete {...props} />;
  } else if (name === "play") {
    const width = size - 4;
    const height = size;
    return <Assets.SvgPlay width={width} height={height} />;
  } else if (name === "search") {
    return <Assets.SvgSearch {...props} />;
  } else if (name === "share") {
    return <Assets.SvgShare {...props} />;
  } else if (name === "comment") {
    return <Assets.SvgComment {...props} />;
  } else if (name === "delete") {
    return <Assets.SvgDelete {...props} />;
  } else if (name === "restore") {
    return <Assets.SvgRestore {...props} />;
  } else if (name === "consoleSearch") {
    return <Assets.SvgConsoleSearch {...props} />;
  } else if (name === "svgMix") {
    return <Assets.SvgMix {...props} />;
  } else if (name === "commentMenu") {
    return <Assets.SvgCommentMenu {...props} />;
  } else if (name === "commentConsole") {
    return <Assets.SvgCommentConsole {...props} />;
  } else if (name === "historyMenu") {
    return <Assets.SvgHistoryMenu {...props} />;
  } else if (name === "swipeRight") {
    return <Assets.SvgSwipeArrowRight {...props} />;
  } else if (name === "swipeLeft") {
    return <Assets.SvgSwipeArrowLeft {...props} />;
  } else if (name === "svgRecent") {
    return <Assets.SvgRecent {...props} />;
  } else if (name === "svgSettingIcon") {
    return <Assets.SvgSettingIcon {...props} />;
  } else if (name === "svgMixed") {
    return <Assets.SvgMixed {...props} />;
  } else if (name === "svgSearchHome") {
    return <Assets.SvgSearchHome {...props} />;
  } else if (name === "svgNewArrow") {
    return <Assets.SvgNewArrow {...props} />;
  } else if (name === "svgTemplates") {
    return <Assets.SvgTemplates {...props} />;
  } else if (name === "svgModeration") {
    return <Assets.SvgModeration {...props} />;
  }

  return null;
};

export default IconView;
